let googleMaps = {
    $el: $("#js-googleMaps"),
    callback: null,

    load(callback) {
        let src

        window.onGoogleMapsLoad = callback || (() => {})

        if (!window.google) {
            src = this.$el.attr('data-src') + '&callback=window.onGoogleMapsLoad'
            this.$el.attr('src', src)
        } else {
            window.onGoogleMapsLoad()
        }
    }
}

export default googleMaps